import { createStore } from 'store-utils';
import { AppFeature, AppFeatureFlags } from '../feature-flags-types';

export const AppFeatureFlagsStore = createStore<AppFeatureFlagsStoreState>(
  {
    [AppFeature.PlaceHolder1]: null,
  },
  'Feature Flags Store',
);

export type AppFeatureFlagsStoreState = AppFeatureFlags;
